import(/* webpackMode: "eager" */ "/codebuild/output/src2740397307/src/cxmapper-web/node_modules/.pnpm/@fontsource-variable+inter@5.2.8/node_modules/@fontsource-variable/inter/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/codebuild/output/src2740397307/src/cxmapper-web/node_modules/.pnpm/react-hot-toast@2.5.1_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2740397307/src/cxmapper-web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2740397307/src/cxmapper-web/src/app/providers/react-query.tsx");
